// config.js
const AppConfig = {
  // Define your variable here
  // serverDomain: 'http://localhost:3001',
  // serverDomain: 'https://templates-api.myvarno.io', // Old backend
  serverDomain: 'https://document-fill-backend-869166735.us-central1.run.app',

  // AI-specific backend for field detection (same as main backend now)
  aiBackendURL: 'https://document-fill-backend-869166735.us-central1.run.app',
};

export default AppConfig;